import React from 'react';
export function EmpathySection() {
  return <section className="py-12 px-4 bg-cloud-grey" data-id="element-24">
      <div className="max-w-4xl mx-auto" data-id="element-25">
        <div className="flex flex-col gap-8 items-center text-center" data-id="element-26">
          <div className="w-full max-w-2xl" data-id="element-27">
            {/* IMAGEN 1 (Mestizo en Calle CDMX) */}
            <div className="w-full rounded-[20px] overflow-hidden relative shadow-lg mb-8" data-id="element-28">
              <img src="https://cdn.magicpatterns.com/uploads/i7BaBeS5zdvoJn9pDQjVsN/imagen_1.png" alt="Perro estresado en la calle de CDMX" className="w-full h-auto" data-id="element-29" />
            </div>

            <h2 className="text-3xl font-bold mb-6 text-gray-900 leading-tight" data-id="element-30">
              Usted no tiene un perro malo, tiene un perro que no sabe gestionar
              su estrés.
            </h2>
            <div className="space-y-4 text-gray-700 text-base max-w-2xl mx-auto" data-id="element-31">
              <p data-id="element-32">
                Cada vez que su perro tira de la correa o ladra
                descontroladamente, su cerebro está inundado de{' '}
                <strong data-id="element-33">cortisol</strong>. No es desobediencia, es
                supervivencia.
              </p>
              <p data-id="element-34">
                El ciclo del cortisol bloquea su capacidad de aprendizaje. Por
                eso, gritarle o usar la fuerza solo empeora el problema,
                confirmando sus miedos.
              </p>
              <p className="font-semibold text-brand-teal" data-id="element-35">
                Es hora de cambiar la culpa por responsabilidad científica.
                Usted puede enseñarle a apagar esa alarma interna.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}